import { render, staticRenderFns } from "./LogIndex.vue?vue&type=template&id=a686fff0&scoped=true&"
import script from "./LogIndex.vue?vue&type=script&lang=js&"
export * from "./LogIndex.vue?vue&type=script&lang=js&"
import style0 from "./LogIndex.vue?vue&type=style&index=0&id=a686fff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a686fff0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a686fff0')) {
      api.createRecord('a686fff0', component.options)
    } else {
      api.reload('a686fff0', component.options)
    }
    module.hot.accept("./LogIndex.vue?vue&type=template&id=a686fff0&scoped=true&", function () {
      api.rerender('a686fff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/udm/LogIndex.vue"
export default component.exports